import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import { colors, typography } from '../../styles';
import ImageWrapper from './ImageWrapper';
import MainCopy from './MainCopy';
import IndexMap from './IndexMap';
import PhotoGalleryList from './PhotoGalleryList';

const styles = css`
  .ImageWrapper_overlay {
    background-color: rgba(183, 150, 65, 0.9);
    display: inline-block;
    width: 600px;
    padding: 10px 20px;
    font-size: 33px;
    color: white;
    border-top: 17px solid ${colors.color2};
    font-family: ${typography.Serif};
    position: relative;
    max-width: calc(100% - 40px);
    top: calc(40vh - 85px);
    z-index: 1;
    @media (min-width: 992px) {
      position: absolute;
      left: 100px;
      top: calc(75vh - 320px);
      padding: 20px 30px 66px 30px;
    }
  }
  .ImageWrapper_headline {
    @media (min-width: 992px) {
      font-size: 73px;
    }
  }
  .ImageWrapper_divider {
    border-top: 2px solid #ffffff;
    margin: 10px 0;
  }
  .ImageWrapper_tagline {
    display: inline-block;
    font-family: inherit;
    font-size: 14px;
    line-height: 1;
    vertical-align: top;
    @media (min-width: 992px) {
      font-size: 18px;
      line-height: 30px;
      vertical-align: bottom;
    }
  }
  .ImageWrapper_button {
    max-width: 300px;
    height: 53px;
    border: 3px solid #fff;
    border-radius: 3px;
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -30px;
    margin: 0 auto;
    background-color: ${colors.color1};

    line-height: 47px;
    color: #ffffff;
    letter-spacing: 4px;
    font-size: 14px;
    font-weight: bold;
    font-family: ${typography.SanSerif};
    text-transform: uppercase;
  }
  .ImageWrapper_woodbridge_wrapper {
    position: absolute;
    right: 0;
    left: 0;
    bottom: -50px;
    height: auto;
    display: none;
    overflow: hidden;
    z-index: 0;
    @media (min-width: 992px) {
      display: block;
    }
    @media (min-width: 1550px) {
      bottom: -70px;
    }
  }
  .ImageWrapper_woodbridge {
    margin-left: -10px;
    line-height: 1;
    font-size: 20vw;
    color: #FFFFFF;
    opacity: 0.3;
    font-family: ${typography.Serif};
  }
  .mobile-divider {
    height: 100px;
    background-color: ${colors.color3Dark};
    @media (min-width:992px) {
      height: 35px;
      background-color: ${colors.color4};
    }
  }
`;

function Index({ page, builder }) {
  const metaTitle = get(page, 'metaTags.title') || 'Woodbridge Communities - Refined Living | Canton, MI';
  const metaDescription = get(page, 'metaTags.description') || 'New home construction in the suburban Detroit area';
  return (
    <PageWrapper className={styles}>
      <PageHelmet elements={{
        title: { content: metaTitle, attrs: {} },
        meta: [
          { name: 'description', content: metaDescription },
          { property: 'og:title', content: metaTitle },
          { property: 'og:description', content: metaDescription },
        ],
      }}
      />
      <ImageWrapper page={page}>
        <div className="ImageWrapper_overlay">
          <h2 className="ImageWrapper_headline">Refined Living</h2>
          <hr className="ImageWrapper_divider" />
          <span className="ImageWrapper_tagline">Elegant Condo Living Throughout the Suburban Detroit Area</span>
          <Link className="ImageWrapper_button" name="communities">Find Your Community</Link>
        </div>
        <div className="ImageWrapper_woodbridge_wrapper">
          <i className="ImageWrapper_woodbridge">Woodbridge</i>
        </div>
      </ImageWrapper>
      <div className="mobile-divider" />
      <MainCopy page={page} builder={builder} />
      <IndexMap builder={builder} />
      <PhotoGalleryList page={page} />
    </PageWrapper>
  );
}

Index.propTypes = {
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

export default withData({
  communities: true,
  plans: true,
  page: 'home_page',
  builder: true,
})(Index);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/index.js